export default {
  en: 'English',
  ja: 'Japanese',
  fr: 'French',
  de: 'Deutsch',
  es: 'Spanish',
  it: 'Italian',
  pt: 'Portuguese',
  zh: 'Chinese',
  nl: 'Dutch',
  ko: 'Korean',
  fi: 'Suomi',
} as const;
